import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/fonts.css'

createApp(App).mount('#app')
